import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDeleteChronologyFact = (matterId: string, subsetId: string, chronologyId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async (factId: string) => {
      const fetchConfig = getFetchConfig({ method: FetchMethod.DELETE });

      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/chronology/fact/${factId}`,
        fetchConfig,
      );

      if (!response.ok) {
        toast.error('Failed to delete fact');
        throw new Error('Failed to delete fact');
      }

      return factId;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QueryEntity.Chronology, { chronologyId }]);
        queryClient.invalidateQueries([QueryEntity.ChronologyFacts, { chronologyId }]);
        toast.success('Fact removed');
      },
      onError: (error) => {
        console.error('Delete Error: ', error);
        toast.error('Failed to delete fact');
      },
    },
  );
};
